import { apiV1Client } from "lib/apiClient";
import { ApiResponse } from "types/api";
import { WORKER_OPERATIONS } from "types/operations";
import { CreateScheduleRequest, UpdateScheduleRequest } from "types/schedule";

const workerPath = "/worker";

type CreateParams = CreateScheduleRequest;

/**
 * スケジュール作成
 */
export const callCreateSchedule = async (input: CreateParams) => {
  const res = await apiV1Client.post<ApiResponse<{ scheduleId: string }>>(
    workerPath,
    {
      operation: WORKER_OPERATIONS.schedule.create,
      data: {
        ...input,
      },
    }
  );
  return res.data.data;
};

type UpdateParams = UpdateScheduleRequest;
/**
 * スケジュール更新
 */
export const callUpdateSchedule = async (input: UpdateParams) => {
  const res = await apiV1Client.post<ApiResponse<{ scheduleId: string }>>(
    workerPath,
    {
      operation: WORKER_OPERATIONS.schedule.update,
      data: {
        ...input,
      },
    }
  );
  return res.data.data;
};

type DeleteParams = {
  scheduleId: string;
  robotId: string;
};
/**
 * スケジュール削除
 */
export const callDeleteSchedule = async (input: DeleteParams) => {
  await apiV1Client.post<ApiResponse<null>>(workerPath, {
    operation: WORKER_OPERATIONS.schedule.delete,
    data: {
      ...input,
    },
  });
};
